import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLiveChat = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M5.64 5.5a10 10 0 0 1 15.34 3.98 10 10 0 0 1 7.73 14.44l-.1.2.77 2.72c.16.56.03 1.16-.34 1.6l-.1.12c-.42.4-1 .58-1.57.48l-.15-.04-2.71-.77-.2.1a10 10 0 0 1-7.62.6l-.32-.12a10 10 0 0 1-5.78-5.47 9.95 9.95 0 0 1-3.3-1l-.22-.1-2.7.76a1.8 1.8 0 0 1-1.47-.23l-.14-.1-.12-.1c-.4-.43-.58-1-.48-1.58l.04-.15.77-2.7-.06-.13A10 10 0 0 1 5.18 5.88l.23-.2.22-.17h.01V5.5Zm15.97 6.1v.05a9.98 9.98 0 0 1-8.8 11.7 8 8 0 0 0 11.05 2.93 1 1 0 0 1 .65-.13l.14.03 2.67.76-.76-2.67a1 1 0 0 1 .04-.66l.06-.13a8 8 0 0 0-5.05-11.87ZM6.88 7.1a8 8 0 1 1 1.03 13.3l-.23-.14-.12-.06-.12-.04a1.01 1.01 0 0 0-.53 0l-2.67.77.76-2.67.03-.14a1 1 0 0 0-.13-.65 8 8 0 0 1 1.97-10.4l.01.03Z",
		clipRule: "evenodd"
	})
});
export default SvgLiveChat;
